var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThreeDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 4,
  height: 16,
  fill: "none",
  viewBox: "0 0 4 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M.683 0v3.198H3.88V0zM.668 9.6h3.215V6.402H.668zM.683 16H3.88v-3.196H.683z",
  clipRule: "evenodd"
})));
export default SvgThreeDots;